var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightDirection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5650",
    "data-name": "Group 5650",
    transform: "translate(-582 -349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(582 349)",
    fill: "#e7ebef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2705",
    "data-name": "Group 2705",
    transform: "translate(594.266 357.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M1286.444,1163.709l-4.957,4.957,4.957,4.956",
    transform: "translate(-1281.487 -1163.709)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line",
    x2: 15.153,
    transform: "translate(0.626 4.955)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-2",
    "data-name": "icon-arrow",
    transform: "translate(0 12.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M1281.487,1163.709l4.957,4.957-4.957,4.956",
    transform: "translate(-1270.665 -1163.709)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line-2",
    "data-name": "line",
    x1: 15.153,
    transform: "translate(0 4.955)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDirection);
export default __webpack_public_path__ + "static/media/flight-direction.9a926fd7.svg";
export { ForwardRef as ReactComponent };